<template>
    <div class="detail">
        <div class="header">
            <div class="left" @click="toIndex()">< 返回</div>
            <div class="span1">
                <span>{{info.teacherName}}老师  考勤详情</span>
            </div>
            <div class="right"></div>
        </div>

        <div>
            <el-form :inline="true" :model="queryParams" label-width="70px">
                <el-form-item label="">
                    <el-select v-model="queryParams.semester" placeholder="选择学年学期" class="label">
                        <el-option v-for="item in semesterList" :key="item.id" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
                </el-form-item>
            </el-form>

            <!-- 校内教师 -->
            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="courseName" label="课程名称" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="gradeName" label="课程覆盖年级" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="classTime" label="上课时间" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="locationName" label="上课地点" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="classNum" label="课时总数" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="needAttendanceNum" label="应出勤次数" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="attendanceNum" label="实际出勤次数" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="attendanceRate" label="出勤率" align="center" show-overflow-tooltip>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
import dayjs from "dayjs";
export default {
    props:['info','semester','semesterList','schoolId'],
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				semester: '',
				grade: '',
			},
			gradeList: [],
			tableData: [],
		}
	},
	watch: {
		'info.teacherId':function(n,o){
			this.pageNum = 1;
			this.queryParams.semester=this.semester;
			this.getDataList();
		},
	},
	created() {},
	methods: {
		async getDataList() {
			let params={
				schoolYearSemester:this.queryParams.semester,
				gradeId:this.queryParams.grade,
				teacherId:this.info.teacherId,
				startDate:'',
				endDate:'',
				orgId:this.schoolId,
				platformCode:sessionStorage.getItem('platformCode'),
				page:this.pageNum,
				limit:this.pageSize,
			}
			let res = await api.teacherCourseAttendance(params);
			if(res.code==='0'){
				this.tableData=res.data.list;
				this.totalPage=res.data.total || 0;
			}
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        toIndex(){
            this.$emit('to-index')
        },
	},
	mounted() {

	},
}
</script>
<style lang="less" scoped>
.detail {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.header {
		height: 60px;
		line-height: 48px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
        align-items: center;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-size: 20px;
			color: #000;
			margin-right: 30px;
		}
        .left, .right{
            width: 60px;
        }
        .left{
            cursor: pointer;
        }
	}

	::v-deep .el-form .el-input__inner {
		// width: 150px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
</style>
